import { render } from "./CalculatorApp.vue?vue&type=template&id=09275e10&ts=true"
import script from "./CalculatorApp.vue?vue&type=script&lang=ts"
export * from "./CalculatorApp.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__